import { gsap, Power3 } from 'gsap';

export default class Overlays {
  constructor() {
    this.params = new URLSearchParams(window.location.search);
    this.boundOpenHandler = this.handleOpenOverlay.bind(this);
    this.boundCloseHandler = this.handleCloseOverlay.bind(this);
    this.boundKeyHandler = this.handleKeyDown.bind(this);

    this.init();
  }

  init() {
    if (this.params.get('enquiry')) {
      this.handleUrlParams(this.params.get('enquiry'));
    }

    document.addEventListener('click', this.boundOpenHandler);
    document.addEventListener('click', this.boundCloseHandler);
    document.addEventListener('keydown', this.boundKeyHandler);

    this.initDevelopmentDropdowns();
  }

  handleOpenOverlay(e) {
    if (e.target.closest('.js-overlay-open')) {
      e.preventDefault();
      const element = e.target.closest('.js-overlay-open');
      this.openOverlay(element);
      this.toggleForm(element);
    }
  }

  handleCloseOverlay(e) {
    if (e.target.closest('.js-overlay-close')) {
      const element = e.target.closest('.js-overlay-close');
      this.closeOverlay(element);
    }
  }

  handleKeyDown(e) {
    if (e.code === 'Enter') {
      if (e.target.closest('.js-overlay-open')) {
        e.preventDefault();
        const element = e.target.closest('.js-overlay-open');
        this.openOverlay(element);
        this.toggleForm(element);
      } else if (e.target.closest('.js-overlay-close')) {
        const element = e.target.closest('.js-overlay-close');
        this.closeOverlay(element);
      }
    }
  }

  initDevelopmentDropdowns() {
    document
      .querySelectorAll('.development-dropdown select')
      .forEach((select) => {
        let thisOverlay = document.querySelector(
          `.js-overlay[data-overlay="enquiry"]`
        );

        select.addEventListener('change', (e) => {
          let parentForm = e.currentTarget.closest('form');
          let devID = parentForm.querySelectorAll('.hid_dev_id input');
          let devName = parentForm.querySelectorAll('.hid_dev_name input');

          devID.forEach((input) => {
            input.value = e.currentTarget.value;
          });
          devName.forEach((input) => {
            input.value =
              e.currentTarget.options[e.currentTarget.selectedIndex].text;
          });
        });
      });
  }

  reinitDynamicContent() {
    this.initDevelopmentDropdowns();
  }

  handleUrlParams(param) {
    let button = document.querySelector(`[data-url-form='${param}']`);
    let enquiryForm = document.querySelector(
      `[data-form="${button.dataset.formToggle}"]`
    );

    if (enquiryForm && button) {
      this.openOverlay(button);
      this.toggleForm(button);
    }
  }

  openOverlay(trigger) {
    document.body.classList.add('no-scroll');
    let thisOverlay = document.querySelector(
      `.js-overlay[data-overlay="${trigger.dataset.overlay}"]`
    );
    let thisCover = thisOverlay.previousElementSibling;
    if (document.querySelector('.js-overlay-active')) {
      this.closeOverlay(
        document.querySelector('.js-overlay-active .js-overlay-close')
      );
    }

    let mapEl = thisOverlay.querySelector('[data-map-id]');

    gsap.to(thisOverlay, {
      duration: 0.3,
      delay: 0.25,
      top: 0,
      display: 'block',
      ease: Power3.in,
      onStart: () => {
        thisOverlay
          .querySelectorAll('[data-extra-field]')
          .forEach((element) => {
            let thisFieldType = element.dataset.extraField;
            if (trigger.hasAttribute('data-' + thisFieldType)) {
              element.value = trigger.getAttribute('data-' + thisFieldType);
            }
          });

        // populate development
        let devDropdown = thisOverlay.querySelectorAll(
          '.development-dropdown select'
        );
        let devID = thisOverlay.querySelectorAll('.hid_dev_id input');
        let devName = thisOverlay.querySelectorAll('.hid_dev_name input');
        let propType = thisOverlay.querySelectorAll('.hid_prop_type input');

        devDropdown.forEach((e) => {
          if (trigger.hasAttribute('data-development-code')) {
            e.value = `${trigger.getAttribute('data-development-code')}`;
          }
        });

        devID.forEach((e) => {
          if (trigger.hasAttribute('data-development-code')) {
            e.value = `${trigger.getAttribute('data-development-code')}`;
          }
        });

        devName.forEach((e) => {
          if (trigger.hasAttribute('data-development-code')) {
            e.value = `${trigger.getAttribute('data-development')}`;
          }
        });

        propType.forEach((e) => {
          if (trigger.hasAttribute('data-prop-name')) {
            e.value = `${trigger.getAttribute('data-prop-name')}`;
          }
        });
      },
      onComplete: () => {
        thisOverlay.classList.add('js-overlay-active');

        if (mapEl) {
          let mapID = mapEl.dataset.mapId;

          let map = window.MapSVG.getById(mapID);
          map.redraw();
        }
      },
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
      gsap.to(thisCover, {
        duration: 0.3,
        delay: 0.3,
        opacity: 1,
        display: 'block',
        ease: Power3.in,
      });
    }
  }

  closeOverlay(trigger) {
    document.body.classList.remove('no-scroll');
    trigger.closest('[data-overlay]').classList.remove('js-overlay-active');
    gsap.to(trigger.closest('[data-overlay]'), {
      duration: 0.3,
      delay: 0.25,
      top: '100%',
      display: 'none',
      ease: Power3.in,
      onStart: () => {
        trigger
          .closest('[data-overlay]')
          .querySelectorAll('[data-extra-field]')
          .forEach((element) => {
            element.value = '';
          });
      },
    });

    if (
      trigger.closest('[data-overlay]').previousElementSibling.style.display ==
      'block'
    ) {
      gsap.to(trigger.closest('[data-overlay]').previousElementSibling, {
        duration: 0.3,
        delay: 0.2,
        opacity: 0,
        display: 'none',
        ease: Power3.in,
      });
    }
  }

  toggleForm(element) {
    if (element.dataset.formToggle) {
      let enquiryForm = document.querySelector(
        `[data-form="${element.dataset.formToggle}"]`
      );
      let formElement = document.querySelector(
        `[data-form-type="${element.dataset.formToggle}"]`
      );

      if (enquiryForm) {
        enquiryForm.checked = true;
      }

      document.querySelectorAll(`[data-form-type]`).forEach((element) => {
        element.classList.add('hidden');
      });
      formElement.classList.remove('hidden');
    }
  }
}
